export default function KlarityCrystalpathIco({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 48 48"
      fill="none"
    >
      <g clip-path="url(#clip0_1507_113248)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33 27H42C42.7954 27.0009 43.5579 27.3173 44.1203 27.8797C44.6827 28.4421 44.9991 29.2046 45 30V39C44.9991 39.7954 44.6827 40.5579 44.1203 41.1203C43.5579 41.6827 42.7954 41.9991 42 42H33C32.2046 41.9991 31.4421 41.6827 30.8797 41.1203C30.3173 40.5579 30.0009 39.7954 30 39V36H27.5C26.6716 36 26 35.3284 26 34.5C26 33.6716 26.6716 33 27.5 33H30V30C30.0009 29.2046 30.3173 28.4421 30.8797 27.8797C31.4421 27.3173 32.2046 27.0009 33 27ZM42 30H33V39H42V30Z"
          fill={color || "#667085"}
          strokeWidth="1"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 22C14.3284 22 15 21.3284 15 20.5V18H18C18.7954 17.9991 19.5579 17.6827 20.1203 17.1203C20.6827 16.5579 20.9991 15.7954 21 15V6C20.9991 5.20463 20.6827 4.4421 20.1203 3.87969C19.5579 3.31728 18.7954 3.00091 18 3H9C8.20463 3.00091 7.4421 3.31728 6.87969 3.87969C6.31728 4.4421 6.00091 5.20463 6 6V15C6.00091 15.7954 6.31728 16.5579 6.87969 17.1203C7.4421 17.6827 8.20463 17.9991 9 18H12V20.5C12 21.3284 12.6716 22 13.5 22ZM18 6H9V15H18V6Z"
          fill={color || "#667085"}
          strokeWidth="1"
        ></path>
        <path
          d="M12.3721 26.7391C12.7595 25.7536 14.2405 25.7536 14.6279 26.7391L15.2555 28.3352C15.9863 30.1942 17.5436 31.6599 19.5188 32.3478L21.2147 32.9384C22.2618 33.3031 22.2618 34.6969 21.2147 35.0616L19.5188 35.6522C17.5436 36.3401 15.9863 37.8058 15.2555 39.6648L14.6279 41.2609C14.2405 42.2464 12.7595 42.2464 12.3721 41.2609L11.7445 39.6648C11.0137 37.8058 9.45636 36.3401 7.4812 35.6522L5.7853 35.0616C4.73823 34.6969 4.73823 33.3031 5.7853 32.9384L7.4812 32.3478C9.45636 31.6599 11.0137 30.1942 11.7445 28.3352L12.3721 26.7391Z"
          fill={color || "#667085"}
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1507_113248">
          <rect width="48" height="48" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
}
